export default __webpack_public_path__ + "static/media/snlc-header.fed06fd8.svg";